import { Component, inject, type OnInit, signal } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map } from 'rxjs';
import { HeaderImageComponent } from '../header-image-component/header-image.component';
import { HeaderNavigationComponent } from '../header-navigation/header-navigation.component';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [RouterOutlet, HeaderNavigationComponent, HeaderImageComponent],
  templateUrl: './main-layout.component.html',
})
export class MainLayoutComponent implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  public readonly headerImageUrl = signal('/assets/logos/FourEnergy-Logo-single-line-RGB-2col.svg');

  ngOnInit() {
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.getChildRoute(this.activatedRoute)),
      filter((route) => route !== null)
    );
  }

  private getChildRoute(route: ActivatedRoute): ActivatedRoute | null {
    while (route.firstChild) {
      route = route.firstChild;
      if (route.snapshot.data.gradient) {
        return route;
      }
    }
    return route;
  }
}
